import React from "react";
import styled from "styled-components";
import { Row, Col } from "react-bootstrap";
import ImageCarousel from "src/components/ImageCarousel/ImageCarousel";
import ResponsiveImage from "src/components/ImageWrapper/ResponsiveImage";

/**
 * ResponsiveImageGrid - Shows a carousel on mobile and a grid on desktop
 * @param {Array} images - Array of image objects with src and alt
 * @param {Object} gridConfig - Grid configuration (xs, sm, md, lg, etc.)
 * @param {Object} carouselConfig - Carousel configuration for mobile
 */
const ResponsiveImageGrid = ({
  images = [],
  gridConfig = { xs: 12, sm: 6, md: 3 },
  carouselConfig = {},
  className = "",
}) => {
  const defaultCarouselSettings = {
    autoplay: true,
    autoplaySpeed: 3000,
    speed: 700,
    arrows: false,
    dots: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    ...carouselConfig,
  };

  return (
    <Wrapper>
      {/* Mobile Carousel */}
      <MobileOnly>
        <ImageCarousel images={images} {...defaultCarouselSettings} />
      </MobileOnly>

      {/* Desktop Grid */}
      <DesktopOnly>
        <Row className={className}>
          {images.map((image, index) => (
            <Col key={index} {...gridConfig}>
              <ResponsiveImage src={image.src} alt={image.alt || `Image ${index + 1}`} />
            </Col>
          ))}
        </Row>
      </DesktopOnly>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  width: 100%;
`;

const MobileOnly = styled.div`
  display: block;
  
  @media (min-width: 768px) {
    display: none;
  }
`;

const DesktopOnly = styled.div`
  display: none;
  
  @media (min-width: 768px) {
    display: block;
  }
`;

export default ResponsiveImageGrid;
